export default "__VITE_ASSET__Cqu4QGP5__"